/*
 * @Author: yzr
 * @Date: 2020-11-24 09:37:03
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-25 10:28:06
 */
import Custom from './custom.vue';

export default Custom;
